import { render, staticRenderFns } from "./OpenSessionCardSkeleton.vue?vue&type=template&id=039b85be&"
import script from "./OpenSessionCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./OpenSessionCardSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports